import { render, staticRenderFns } from "./VacantJobFromUser.vue?vue&type=template&id=58c27707&scoped=true&"
import script from "./VacantJobFromUser.vue?vue&type=script&lang=js&"
export * from "./VacantJobFromUser.vue?vue&type=script&lang=js&"
import style0 from "./VacantJobFromUser.vue?vue&type=style&index=0&id=58c27707&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c27707",
  null
  
)

export default component.exports